<!-- Sidebar item -->
<li
  class="nav-item"
  [class.active]="item.expanded || item.active"
  [class.px-3]="item.img"
  *ngIf="!item.divider"
>
  <a
    class="nav-link pb-1"
    href
    role="button"
    [class.dropdown-indicator]="(item.items | async)?.length"
    [class.expanded]="item.expanded"
    [class.active]="item.active"
    [class.px-0]="item.img"
    (click)="onClick(); (false)"
    [class.new-marker]="item.badge | async"
    *ngIf="!item.disabled || !(item.disabled | async); else disabled"
  >
    <div class="d-flex align-items-center">
      <span class="nav-link-icon">
        <img
          *ngIf="item.img | async as image"
          src="./assets/img/{{ image }}?v={{ version }}"
          alt=""
          class="img-fluid"
        />
        <i
          *ngIf="!item.img"
          class="{{ item.icon }} mr-3 d-inline-block h-100 mt-2"
        ></i> </span
      ><span class="nav-link-text">{{ item.name | translate }}</span>
    </div>
  </a>
  <!-- ACL disabled link -->
  <ng-template #disabled>
    <a class="nav-link pb-1"
      href
      role="button"
      [class.dropdown-indicator]="(item.items | async)?.length"
      [class.px-0]="item.img"
      (click)="(false)"
      [class.new-marker]="item.badge | async"
    >
      <div class="d-flex align-items-center">
        <span class="nav-link-icon">
          <i
            class="fe fe-lock mr-3 d-inline-block h-100 mt-2"
          ></i> </span
        ><span class="nav-link-text line-through">{{ item.name | translate }}</span>
      </div>
    </a>
  </ng-template>

  <!-- Submenu items -->
  <ul class="nav collapse show mb-3" *ngIf="item.expanded" @expandDown>
    <ng-container *ngFor="let subitem of item.items | async">
      <app-sidebar-submenu-item
        class="w-100"
        *ngIf="!subitem.visible || (subitem.visible | async)"
        [item]="subitem"
        (clicked)="onClickSubmenu($event)"
      ></app-sidebar-submenu-item>
    </ng-container>
  </ul>
</li>
